import section6 from "./compare-floor-plan-digital-and-analog.jpg";
import section4 from "./digital-floor-plan.jpg";
import section1 from "./draw-floor-plan-with-pencil.jpg";
import section5 from "./drawing-floor-plan-by-hand.jpg";
import section2 from "./Grundriss-Zeichnung.jpg";
import section3 from "./Laptop-Grundriss.jpg";
import header from "./measure-real-estate.jpg";

export { header, section1, section2, section3, section4, section5, section6 };
